import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Reveal, Eyebrow } from "./Reveal";
import { PRODUCTS, waWithMessage } from "./data";

const inputCls =
  "w-full rounded-xl border border-emerald-500/20 bg-[#050B07] px-4 py-3.5 text-sm text-white placeholder-slate-500 outline-none transition-colors duration-300 focus:border-emerald-400";

export const Quotation = () => {
  const [form, setForm] = useState({
    name: "",
    company: "",
    phone: "",
    location: "",
    quantity: "",
    grade: "KARM 006",
  });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const msg = [
      "Hello KARM INDUSTRIES, I would like a quotation.",
      "",
      `Name: ${form.name}`,
      form.company && `Company: ${form.company}`,
      `Phone: ${form.phone}`,
      `Product Grade: ${form.grade}`,
      `Required Quantity: ${form.quantity} Tons`,
      `Delivery Location: ${form.location}`,
    ]
      .filter(Boolean)
      .join("\n");
    toast.success("Opening WhatsApp with your enquiry…");
    window.open(waWithMessage(msg), "_blank", "noopener,noreferrer");
  };

  return (
    <section id="quotation" data-testid="quotation-section" className="py-20 lg:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <Reveal className="text-center">
            <Eyebrow>Fast Response</Eyebrow>
            <h2 className="font-display mt-4 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="quotation-heading">
              Get Quotation
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base text-slate-400">
              Fill in your requirement — the enquiry opens directly in WhatsApp on
              8989099599, pre-filled and ready to send.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <form
              onSubmit={submit}
              data-testid="quotation-form"
              className="glow-border mt-10 rounded-3xl border border-emerald-500/25 bg-[#0B150F]/80 p-6 backdrop-blur-xl sm:p-10"
            >
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                <div>
                  <label htmlFor="q-name" className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-400">Your Name *</label>
                  <input id="q-name" data-testid="quotation-name-input" required className={inputCls} placeholder="Full name" value={form.name} onChange={set("name")} />
                </div>
                <div>
                  <label htmlFor="q-company" className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-400">Company Name</label>
                  <input id="q-company" data-testid="quotation-company-input" className={inputCls} placeholder="Company / firm" value={form.company} onChange={set("company")} />
                </div>
                <div>
                  <label htmlFor="q-phone" className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-400">Phone Number *</label>
                  <input id="q-phone" data-testid="quotation-phone-input" required type="tel" pattern="[0-9+ -]{10,15}" className={inputCls} placeholder="Your contact number" value={form.phone} onChange={set("phone")} />
                </div>
                <div>
                  <label htmlFor="q-location" className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-400">Delivery Location *</label>
                  <input id="q-location" data-testid="quotation-location-input" required className={inputCls} placeholder="City, State" value={form.location} onChange={set("location")} />
                </div>
                <div>
                  <label htmlFor="q-quantity" className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-400">Required Quantity (Tons) *</label>
                  <input id="q-quantity" data-testid="quotation-quantity-input" required type="number" min="1" className={inputCls} placeholder="e.g. 25" value={form.quantity} onChange={set("quantity")} />
                </div>
                <div>
                  <label htmlFor="q-grade" className="mb-2 block text-xs font-bold uppercase tracking-widest text-slate-400">Product Grade *</label>
                  <select id="q-grade" data-testid="quotation-grade-select" className={inputCls} value={form.grade} onChange={set("grade")}>
                    {PRODUCTS.map((p) => (
                      <option key={p.code} value={p.code} className="bg-[#050B07]">
                        {p.code} — {p.size} ({p.price}/Ton)
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <button
                type="submit"
                data-testid="quotation-submit-button"
                className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-emerald-500 py-4 text-sm font-bold uppercase tracking-wider text-[#050B07] transition-all duration-300 hover:bg-emerald-400 hover:shadow-[0_0_36px_rgba(16,185,129,0.45)]"
              >
                <MessageCircle className="h-5 w-5" />
                Send Enquiry on WhatsApp
              </button>
              <p className="mt-4 text-center text-xs text-slate-500">
                No payment, no sign-up — your enquiry goes straight to our sales team on WhatsApp.
              </p>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
